import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledFilterDistanceContainer = styled.div`
  ${() => `
    display: flex;
    flex-direction: column;
    @media (min-width: ${Breakpoints.b960}px) {
        flex-direction: row;
        align-items: center;
        justify-content: center;
        column-gap: 13px;
        width: 100%;
    }
`}
`;

export const StyledFilterDistanceLabel = styled.div`
  ${() => `
    .filter-distance_mobile-label {
        padding-bottom: 45px;
        @media (min-width: ${Breakpoints.b960}px) {
            display: none;
        }


    }
    .filter-distance_desktop-label {
        display: none;
        @media (min-width: ${Breakpoints.b960}px) {
            display: block;
        }
    }
`}
`;

export const StyledFilterSliderContainer = styled.div`
  ${() => `
    width: 100%;
    position: relative;

    .range-labels {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        position: absolute;
        top: -40px;
        left: 0;
        @media (min-width: ${Breakpoints.b960}px) {
            top: 0;
            margin-top: 12px;
        }
    }
    @media (min-width: ${Breakpoints.b960}px) {
        max-width: 291px;
        width: 100%;
        padding: 0 ;
        .MuiSlider-markLabel {
            top: 34px!important;
        }
    }
`}
`;
